module.exports = __webpack_public_path__ + "img/service_persons.36fb195e.jpg";